var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMainScript = function SvgMainScript(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5211.25 -2117.724 31.079 39.816",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .mainScript-1 {\n        fill: #fff;\n      }\n\n      .mainScript-1, .mainScript-2 {\n        stroke: #585858;\n        stroke-width: 0.5px;\n      }\n\n      .mainScript-2, .mainScript-3 {\n        fill: none;\n      }\n\n      .mainScript-3 {\n        stroke: #f0f0f0;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2819",
    transform: "translate(-5832.25 -2688.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    className: "mainScript-1",
    d: "M2.184,0H28.4a2.184,2.184,0,0,1,2.184,2.184V37.132A2.184,2.184,0,0,1,28.4,39.316H7.193L0,32.149V2.184A2.184,2.184,0,0,1,2.184,0Z",
    transform: "translate(651.829 610.702) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    className: "mainScript-2",
    d: "M0,0H7.643V7.711",
    transform: "translate(651.829 578.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2818",
    transform: "translate(625.934 585.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    className: "mainScript-3",
    d: "M5087,5534.875h21.23",
    transform: "translate(-5087 -5531.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    className: "mainScript-3",
    d: "M5087,5534.875h21.23",
    transform: "translate(-5087 -5527.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    className: "mainScript-3",
    d: "M5087,5534.875h13.64",
    transform: "translate(-5087 -5523.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    className: "mainScript-3",
    d: "M5087,5534.875h7.065",
    transform: "translate(-5087 -5534.875)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainScript, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainScript.ced92c86.svg";
export { ForwardRef as ReactComponent };